import React from 'react'

const Checkout = () => {
  return (
    <div>
      <div>checkout</div>
      <div>
      <button>Proceed To Checkout</button>
      </div>
    </div>
  )
}

export default Checkout
